import './productCard.scss';

import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Pill, Size } from '@eliberty/design-system-react';

import { FormattedCurrency } from '~atoms';
import { ResponsiveSize } from '~constants';
import { useMediaQuery } from '~hooks';
import { HubProduct, Taxon } from '~types/appsync.types';

interface ProductCardProps {
  /** The product of the card */
  product: HubProduct;
  /** Called when the "Discover" button is clicked. */
  onDiscoverButtonClick: (productCategoryShortname: string) => void;
}

/** Description of component ProductCard */
const ProductCard = ({ product, onDiscoverButtonClick }: ProductCardProps) => {
  const { price, listing, taxons, productCategoryShortname } = product;
  const { image, title, description } = listing || { description: null, image: null };

  const containerRef = useRef(null);
  const isMobile = useMediaQuery(ResponsiveSize.SCREEN_S_MOBILE);
  const isTablet = useMediaQuery(ResponsiveSize.SCREEN_M_TABLET);

  const displayPrice = () => {
    if (price) {
      return (
        <article className='ProductCard_price'>
          <div className='ProductCard_priceValue'>
            <FormattedCurrency value={price.value} currency={price.currency} />
          </div>
          <div className='ProductCard_priceDescription'>Indicative price for 1 adult</div>
        </article>
      );
    }
  };

  const handleDiscoverButtonClick = () => {
    onDiscoverButtonClick(productCategoryShortname);
  };

  return (
    <li className='ProductCard' ref={containerRef}>
      <article className='ProductCard_article'>
        {!isMobile && image?.thumbnailUrl && (
          <div className='ProductCard_image'>
            <img src={image.thumbnailUrl} alt='TODO' />
          </div>
        )}
        <div className='ProductCard_content'>
          <div className='ProductCard_header'>
            {taxons !== null && taxons !== undefined && taxons.length > 0 && (
              <div className='ProductCard_badges'>
                {taxons.map((badge: Taxon) => (
                  <Pill key={badge.code} text={badge.name} />
                ))}
              </div>
            )}
            {!isMobile && displayPrice()}
          </div>
          <div className='ProductCard_textContent'>
            <h2 className='ProductCard_title'>{title}</h2>
            <div className='ProductCard_description'>{description}</div>
          </div>
          {isMobile && image?.thumbnailUrl && (
            <div className='ProductCard_image'>
              <img src={image.thumbnailUrl} alt='TODO' />
            </div>
          )}
          {isMobile && displayPrice()}
          <div className='ProductCard_buttons'>
            <Button
              size={isTablet || isMobile ? Size.M : Size.L}
              fullWidth={isMobile}
              onClick={handleDiscoverButtonClick}
            >
              <FormattedMessage defaultMessage='Discover' id='discover' />
            </Button>
          </div>
        </div>
      </article>
    </li>
  );
};
export default ProductCard;
